import React, { useEffect } from 'react';
import { Avatar, Card, Col, Row } from 'antd';
import styled from 'styled-components';
import { PageTitle, StyledLinkButton } from '../Styled/GlobalStyles';
import { logEvent } from '../../util/Analytics';

const LinkCard = styled(Card)`
  width: 450px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;

const LinkTitle = styled.h3`
  color: #2c3e50;
  font-size: 24px;
  margin-bottom: 20px;
`;

type PayCargoLink = {
  title: string;
  url: string;
  initials: string;
  color: string;
};

export const PayCargo = () => {
  const links: PayCargoLink[] = [
    {
      title: 'Elizabeth CES',
      url: 'https://app.paycargo.com/shipAndPay?region=US&vendor=278851&vendorId=278851',
      initials: 'ELZ',
      color: '#23386c',
    },
    {
      title: 'Baltimore CES',
      url: 'https://app.paycargo.com/shipAndPay?region=US&vendor=278851&vendorId=286095',
      initials: 'BAL',
      color: '#38671b',
    },
    {
      title: 'Philadelphia CES',
      url: 'https://app.paycargo.com/shipAndPay?region=US&vendor=278851&vendorId=281312',
      initials: 'PHL',
      color: '#b99340',
    },
    {
      title: 'Safeway Trucking',
      url: 'https://app.paycargo.com/shipAndPay?region=US&vendor=286871&vendorId=286871',
      initials: 'SFY',
      color: '#5040b9',
    },
  ];

  const navigateToLink = (link: PayCargoLink) => {
    logEvent(`pay_cargo_${link.initials}`);
    window.open(link.url, '_blank');
  };

  useEffect(() => {
    document.title = 'Pay Cargo';
    // logPageView('Rail Move Request');
  }, []);

  return (
    <>
      <PageTitle>Pay Cargo</PageTitle>
      <Row gutter={[20, 20]}>
        {links.map((link, index) => (
          <div key={index}>
            <Col key={index} span={24}>
              <Row justify={'center'}>
                <LinkCard>
                  <Row>
                    <Col span={8} push={8}>
                      <Avatar size={60} style={{ display: 'flex', backgroundColor: link.color }}>
                        {link.initials}
                      </Avatar>
                    </Col>
                  </Row>
                  <LinkTitle>{link.title}</LinkTitle>
                  <StyledLinkButton onClick={() => navigateToLink(link)}>Go to {link.title}</StyledLinkButton>
                </LinkCard>
              </Row>
            </Col>
          </div>
        ))}
      </Row>
    </>
  );
};
